import http from "app/services/httpService";
import config from "config.json";
const { apiUrl } = config;

const getApiPartner = async (searchText) => {
  try {
    const url = `${apiUrl}/apipartner/all${
      searchText ? `?searchText=${searchText}` : ""
    }`;
    const data = await http.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const getMerchants = async (searchText) => {
  try {
    const url = `${apiUrl}/members/merchants/search-by-distributor${
      searchText ? `?searchText=${searchText}` : ""
    }`;
    const data = await http.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const getAllMembers = async (searchText) => {
  try {
    const url = `${apiUrl}/members/search-all-member${
      searchText ? `?searchText=${searchText}` : ""
    }`;
    const data = await http.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};
// update
const updateRdsAgentService = async (memId, values) => {
  try {
    const url = `${apiUrl}/RdsAgentOnBoarding/update/member/${memId}`;
    const { data } = await http.post(url, values);
    return data;
  } catch (error) {
    throw error;
  }
};
//export
const exportList = async (queryString) => {
  try {
    const url = `${apiUrl}/RdsAgentOnBoarding/member/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await http.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

//get data by id
const getDataById = async (id) => {
  const { data } = await http.get(`${apiUrl}/RdsAgentOnBoarding/member/${id}`);
  return data;
};

const getAllRdsAgent = async (queryString) => {
  const data = await http.get(
    `${apiUrl}/RdsAgentOnBoarding/all${queryString ? `?${queryString}` : ""}`
  );
  return data;
};

const getPartnerByText = async (searchText) => {
  const data = await http.get(
    `${apiUrl}/apipartner/search-all-apiuser${
      searchText ? `?searchText=${searchText}` : ""
    }`
  );
  return data;
};

const getUsergroups = async (queryString) => {
  const data = await http.get(
    `${apiUrl}/apiusergroups${queryString ? `?${queryString}` : ""}`
  );
  return data;
};

const getDistById = async (id) => {
  const data = await http.get(`${apiUrl}/apipartner/distributors/${id}`);
  return data;
};

export {
  getApiPartner,
  getMerchants,
  getAllMembers,
  updateRdsAgentService,
  exportList,
  getDataById,
  getAllRdsAgent,
  getPartnerByText,
  getUsergroups,
  getDistById,
};
